var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.4451 15.6733L11.3146 0.543166C10.9647 0.192942 10.4975 0 9.99942 0C9.50131 0 9.03416 0.192942 8.68421 0.543166L7.56996 1.65714C6.84491 2.38302 6.84491 3.56278 7.56996 4.28756L20.2754 16.9929L7.55586 29.7124C7.20591 30.0627 7.0127 30.5295 7.0127 31.0274C7.0127 31.5258 7.20591 31.9926 7.55586 32.3431L8.67011 33.4568C9.02034 33.8071 9.48721 34 9.98532 34C10.4834 34 10.9506 33.8071 11.3005 33.4568L26.4451 18.3129C26.7958 17.9615 26.9885 17.4924 26.9874 16.9938C26.9885 16.4932 26.7958 16.0244 26.4451 15.6733Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "static/media/right.92979520b7871c369fd169c2466389a1.svg";
export { ForwardRef as ReactComponent };